/* eslint-disable react/style-prop-object */
/**
 * 用户隐私协议
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
/* eslint-disable*/
import { isApp } from '@lib/utils.js';
import * as app from '../../../lib/app';

/* eslint-disable class-methods-use-this */
class Agreement extends Component {
  static run() {
    ReactDOM.render(<Agreement />, document.getElementById('app'));
  }

  constructor() {
    super();
    this.jumpToAuthcall = this.jumpToAuthcall.bind(this);
    this.jumpToSdkcontents = this.jumpToSdkcontents.bind(this);
  }

  jumpToAuthcall() {
    const url = `${location.protocol}//${
      location.host
    }${location.pathname.replace('useragreement', 'authcall')}`;
    setTimeout(() => {
      if (isApp) {
        app.openUrl('useragreement', 'authcall');
      } else {
        location.href = url;
      }
    }, 200);
  }

  jumpToSdkcontents() {
    const url = `${location.protocol}//${
      location.host
    }${location.pathname.replace('useragreement', 'sdkcontents')}`;
    setTimeout(() => {
      if (isApp) {
        app.openUrl('useragreement', 'sdkcontents');
      } else {
        location.href = url;
      }
    }, 200);
  }

  render() {
    return (
      <div style='font-family: 宋体; color: rgb(0, 0, 0);'>
        <p
          class='MsoNormal'
          align='center'
          style='margin: 5pt 0pt; text-align: center; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-family: 微软雅黑; font-size: 13.5pt;'>
            美团排队隐私政策
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>
            <font face='宋体'>版本发布日期：</font> 202
          </span>
          <span style='font-size: 10.5pt;'>3</span>
          <span style='font-size: 10.5pt;'>
            <font face='宋体'>年</font>{" "}
          </span>
          <span style='font-size: 10.5pt;'>&nbsp;</span>
          <span style='font-size: 10.5pt;'>
            <font face='宋体'>1月</font>{" "}
          </span>
          <span style='font-size: 10.5pt;'>&nbsp;</span>
          <span style='font-size: 10.5pt;'>10日</span>
          <span style='font-size: 13.5pt;'>
            <br />
          </span>
          <span style='font-size: 10.5pt;'>
            <font face='宋体'>版本生效日期：</font> 202
          </span>
          <span style='font-size: 10.5pt;'>3</span>
          <span style='font-size: 10.5pt;'>
            <font face='宋体'>年</font>{" "}
          </span>
          <span style='font-size: 10.5pt;'>&nbsp;</span>
          <span style='font-size: 10.5pt;'>
            <font face='宋体'>1月</font>{" "}
          </span>
          <span style='font-size: 10.5pt;'>&nbsp;</span>
          <span style='font-size: 10.5pt;'>17日</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>美团排队（以下或称</font>
            “我们”）非常注重保护个人信息，我们深知个人信息的重要性，并将按照法律法规要求和业界成熟的安全标准，
            采取相应的安全保护措施来保护商户（以下或称“您”）提供给我们或我们向您收集的个人信息。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <u>
              <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
                <font face='宋体'>
                  【特别提示】请您在使用我们提供的各项产品
                </font>
                /服务前，仔细阅读并充分理解本《隐私政策》（重点内容我们已将字体加粗请您特别关注）并作出相应选择
              </span>
            </u>
          </b>
          <u>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              <font face='宋体'>。</font>
            </span>
          </u>
          <b>
            <u>
              <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
                <font face='宋体'>一旦您使用或继续使用我们的产品</font>
                /服务时，即意味着您同意我们按照本隐私政策收集、使用、保存、共享和保护您的相关信息。
              </span>
            </u>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 13.5pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <u>
              <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
                <font face='宋体'>
                  如对本隐私政策有任何疑问，您可以通过本隐私政策
                </font>
                “如何联系我们”中提供的方式与我们联系。
              </span>
            </u>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>美团排队产品</font>
            /服务（以下或称“我们的产品/服务”）是指美团排队的
          </span>
          <span style='font-size: 10.5pt;'>
            网络及技术服务提供者互诚信息技术（上海）有限公司
          </span>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>通过下述途径向您提供的产品</font>
            /服务：包括但不限于美团排队App、美团开店宝App、客户端以及相关微信开放平台账号或小程序等。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            本政策所称的美团排队及其关联方是指
          </span>
          <span style='font-size: 10.5pt;'>
            互诚信息技术（上海）有限公司
          </span>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>及现有和</font>
            /或未来设立的相关关联公司的单称或合称。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              请您注意
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            ，
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              <font face='宋体'>您应保证在使用我们的产品</font>
              /服务所提供的一切数据信息均为真实，且经过合法途径获得，
              如其中包含第三方个人信息（如您的员工信息、使用美团排队服务用户或会员的手机号、供应商信息以及您后续使用新增功能时所提供的其他个人信息），
              请确认您已取得该信息所有方的充分、合法的授权，一旦您在使用我们服务的过程中提供此类信息，
              我们将认为该类信息均为您有权处理，不存在任何违反法律、法规或侵犯任何第三方合法权利的事由/瑕疵/场景。
              本政策不适用于您通过我们的产品/服务而接入的其他第三方产品/服务(“其他第三方”，包括但不限于您的交易相对方、任何第三方网站以及第三方服务提供者)，
              具体规定请参照该第三方的隐私政策或类似声明。
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-family: 微软雅黑; font-size: 13.5pt;'>
            <br />
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              一、我们如何收集和使用您的个人信息
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            我们会出于本政策所述的以下目的，收集和使用您的个人信息，请注意，无法与任何特定个人直接建立联系的数据，不属于个人信息。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            （一）您向我们提供的信息
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            1
          </span>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            、帮助您登录我们的商户管理后台
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>为登录我们的商户管理后台（美团排队</font>APP），
          </span>
          <span style='font-size: 10.5pt;'>
            以便我们为您提供对应的服务，您需要提供
          </span>
          <b>
            <span style='font-size: 10.5pt;'>
              手机号码、网络身份识别信息（如账号、密码等）
            </span>
          </b>
          <span style='font-size: 10.5pt;'>等，或者</span>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            您也可以直接使用我们关联账号（如美团开店宝、美团收银智能版）登录我们商户管理版后台，此时，您需要提供
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              关联账号信息（关联账号的账号、密码等）
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            以便您能够正常登录。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>
            2、更好的为您提供服务
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>
            <font face='宋体'>为便于向您提供产品</font>
            /服务，我们有权从身份校验、完成交易、售后及用户服务、提供安全保障等多种角度，收集您向我们提供的
          </span>
          <b>
            <span style='font-size: 10.5pt;'>
              联系人信息（姓名、性别、电话号码等）、法定代表人信息（姓名、手机号、身份证号等）、实名身份信息
              （如身份证等载明您实名身份的照片、复印件、号码、您的照片或者人脸识别进行认证等）、联系地址、电子邮箱、银行账户或其他支付工具的账户信息
            </span>
          </b>
          <b>
            <span style='font-size: 10.5pt;'>等。</span>
          </b>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='font-size: 10.5pt;'>
              为便于您在使用服务过程中扫码、拍照、上传图片等，您可以选择开启系统的相册权限，通过主动上传图片、视频等方式授权我们访问您的相册。
              此项功能您可以在系统权限中关闭，一旦关闭您将可能无法通过上传图片、视频等方式进行更换头像、发布带图点评等，但不会影响您享受美团排队服务的基本功能。
            </span>
          </b>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='font-size: 10.5pt;'>
              为便于您在使用服务过程中更好地连接蓝牙服务，通过所提供的位置信息更准确使某些连接任务（例如通过蓝牙低功耗
            </span>
          </b>
          <b>
            <span style='font-size: 10.5pt;'>
              &nbsp;(BLE) 连接到附近的设备）
            </span>
          </b>
          <b>
            <span style='font-size: 10.5pt;'>
              能更好地提供您便利。例如连接附近打印机、蓝牙音箱等其他设备。此项功能您可以在系统权限中关闭，
              一旦关闭您将可能无法通过上传图片、视频等方式进行更换头像、发布带图点评等，但不会影响您享受美团排队服务的基本功能。
            </span>
          </b>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='font-size: 10.5pt;'>
              您在使用服务的过程中所提交的任何文字、照片、视频等各种形式的信息，也可能会包含或者关联到您的个人信息
            </span>
          </b>
          <span style='font-size: 10.5pt;'>
            ，我们将对于上述信息中涉及的个人信息予以严格保护。
          </span>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='font-size: 10.5pt;'>
              <font face='宋体'>在实名认证的场景下，美团排队</font>
              APP将向合作的第三方提交您的前述信息，并从合法保存有您个人信息的第三方处获得、保存有关您身份信息的验证结果。
            </span>
          </b>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>3</span>
          <span style='font-size: 10.5pt;'>
            、我们在您使用服务过程中收集的信息
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>
            为向您展示有关排队订单信息，我们会收集您在使用我们服务过程中产生的
          </span>
          <b>
            <span style='font-size: 10.5pt;'>
              排队订单信息（如排队顾客预留联系方式、就餐人数、就餐意向等）
            </span>
          </b>
          <span style='font-size: 10.5pt;'>
            用于向您展示及便于您对您门店的排队情况进行管理。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>
            为了满足法律法规及提供服务的基本要求，保障您的账号安全与系统运行安全以及更好的使用我们的产品，提升产品问题排查效率，我们会收集您的
          </span>
          <b>
            <span style='font-size: 10.5pt;'>
              日志信息、订单信息、浏览及搜索信息、位置信息、设备信息、行为偏好，问题上报描述，
              联系电话以及您在使用服务过程中所提交的任何文字、照片、视频信息等并将您在使用我们关联方的某项服务中提供的信息结合起来，进行综合统计、分析以形成用户画像
            </span>
          </b>
          <span style='font-size: 10.5pt;'>
            <font face='宋体'>，用来向您推荐或展示您可能感兴趣的产品</font>
            /服务信息。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>4</span>
          <span style='font-size: 10.5pt;'>
            、当您与我们联系时，我们
          </span>
          <b>
            <span style='font-size: 10.5pt;'>
              <font face='宋体'>可能会收集您的通信</font>
              /通话记录和内容或您留下的联系方式
            </span>
          </b>
          <span style='font-size: 10.5pt;'>
            ，以便与您联系、帮助您解决问题，或记录相关问题的处理方案及结果。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            5
          </span>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            、当您参与我们的推广活动和问卷调查过程中，我们可能会收集您主动提供的相关信息。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            （二）我们可能间接收集到的您的个人信息
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            为能向您提供更优质的服务，同时为能确认交易状态及为您提供售后与争议解决服务，
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              您授权我们通过您选择的交易对象和交易直接涉及的第三方信息系统、支付机构等收集与交易进度相关的您的交易、支付、服务等信息，
              或者将您的信息共享给上述服务提供者，以便于我们处理您的订单并保证服务的顺利完成，或者更好地预防诈骗、刷单等恶意行为
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>
              。我们会依据法律法规的要求以及与第三方的约定，在您授权范围内向美团排队
            </font>
            APP的关联方、合作伙伴等获得您的有关信息，并对其信息来源的合法性进行确认后使用您的这些信息。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>（三）改进我们的产品</font>/服务
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>
            为改善我们的产品或服务、向您提供个性化的信息搜索及交易服务，使您及时了解丰富的商品信息，提升服务体验，
          </span>
          <b>
            <span style='font-size: 10.5pt;'>
              我们会根据您的浏览及搜索记录、设备信息、位置信息、订单信息，提取您的浏览、搜索偏好、行为习惯、位置信息等特征，
              基于特征标签进行间接人群画像并展示、推送相关信息，包括通过短信、电话、邮件、线上展示各种方式向你推送营销活动信息、商品交易信息、促销信息、调研问卷。
              如果您不同意接收来自我们的推送信息，可以通过相应的退订方式进行退订，或者通过拨打商服电话明确表示拒绝
            </span>
          </b>
          <span style='font-size: 10.5pt;'>。</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            （四）设备权限调用
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            为确保相关业务功能的正常实现，我们需要根据具体的使用场景调用对应的必要权限，并在调用前向您弹窗询问，具体的权限调用说明详见链接：
          </span>
          <span
            style='color: rgb(0, 0, 255); text-decoration: underline; font-size: 10.5pt;' 
            onClick={this.jumpToAuthcall}
					>
            Android 系统权限调用说明
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span>
              您可以在设备的设置中选择关闭部分或者全部权限，这可能导致对应的业务功能无法实现或者无法达到预期效果。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            （五）为您提供安全保障
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>
            为您提供安全保障为了保障您的账号安全、交易安全以及系统运行安全，满足法律法规和我们协议规则的相关要求，在您访问及使用我们的产品/服务过程中，经您授权我们会获取您的设备信息、网络状态信息，包括您使用的设备型号、硬件序列号、设备MAC地址、唯一设备识别码（如IMEI/MEID/IMSI/AndroidID/IDFA/IDFV/OAID、SIM卡IMSI、ICCID信息等设备标识符）、运行中进程信息、移动应用列表、<a href="https://fe-config.meituan.com/bm/config/eia59b6h023i964hc4.html">传感器信息（点击查看）</a>、WIFI状态、电信运营商等软硬件特征信息。未经您的授权，我们不会提前获取以上信息。
            </font>
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>
              为提高您使用我们提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，
			  我们可能会使用或整合您的个人信息以及我们的关联方、合作伙伴取得您授权或者依法共享的信息，
			  根据您的使用习惯和常用软件信息来综合判断您的账号及交易风险，包括验证身份，
			  预防、发现、调查可能存在的欺诈、网络病毒、网络攻击的安全风险以及违反我们或关联方协议、政策或规则的行为，
			  以保护您、其他用户、我们或关联方的合法权益，并记录一些我们认为有风险的链接
            </font>
            (“URL”)。
          </span>
        </p>
       
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            （六）征得同意的例外
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            请您知悉，以下情形中，我们收集、使用个人信息
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              无需
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            征得您的授权同意：
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            1、与国家安全、国防安全有关的；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            2、与公共安全、公共卫生、重大公共利益有关的；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            3、与犯罪侦查、起诉、审判和判决执行等有关的；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            5、所收集的个人信息是个人信息主体自行向社会公众公开的；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            7、根据您的要求签订合同所必需的；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            9、为合法的新闻报道所必需的；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            11、法律法规规定的其他情形。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              <font face='宋体'>二、我们如何使用</font>Cookie和同类技术
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              （一）
            </span>
          </b>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              Cookie的使用
            </span>
          </b>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>
              为确保网站正常高效运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的设备终端
            </font>
            /系统上存储名为Cookie的小数据文件。Cookie会帮助您在后续访问我们网站时调用您的信息，简化您填写个人信息(例如一键登录等)的流程；
			为您提供安全购物的偏好设置；帮助您优化对广告的选择与互动;保护您的数据安全等。我们不会将Cookie用于本隐私政策所述目的之外的任何用途。
			您可根据自己的偏好管理或删除Cookie。您可以清除计算机或移动设备上保存的所有Cookie，您有权接受或拒绝Cookie。
			大多数浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie；
			另外，您也可以清除软件内保存的所有Cookie。但您可能因此无法完全体验我们某些便捷性和安全性的服务功能。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              （二）网络
            </span>
          </b>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              Beacon和同类技术的使用
            </span>
          </b>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            除
          </span>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
		  	    Cookie外，我们网页上常会包含一些电子图象
      			(称为&quot;单像素&quot;GIF文件或&quot;网络Beacon&quot;)等其他同类技术，
      			它们可以帮助网站计算浏览网页的用户或访问某些Cookie。我们使用网络Beacon的方式有:
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            1、我们通过在我们网站上使用网络Beacon，计算用户访问数量，并通过访问Cookie辨认注册用户。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            2、我们通过得到的Cookie信息，可以在我们网站提供个性化服务。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            三、
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              我们如何共享、转让、公开披露您的个人信息
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            （一）共享
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            我们不会与美团点评以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              基于法定情形下
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            ：根据法律法规的规定、诉讼争议解决需要，或行政、司法等有权机关依法提出的要求；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              与关联公司共享
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            ：为向您提供一致化服务以及便于您进行统一管理，我们会基于必要性的前提下将您的个人信息与我们的关联公司共享；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              与合作伙伴分享
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            ：仅为实现本政策中声明的目的，我们的某些服务将由业务合作伙伴提供，我们可能会向业务合作伙伴共享为您提供服务所必要的
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              排队订单信息、位置信息、账户信息、支付信息
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            等，以保障为您提供的服务顺利完成。
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              我们的业务合作伙伴包括供应商、第三方服务合作商等业务合作伙伴；
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              基于协议约定
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>：依据您与我们签署的相关协议</font>
            (包括在线签署的电子协议及美团平台规则)或法律文件，有必要向第三方共享时；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              基于合理商业习惯
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            ：例如与第三方共享联合营销活动中的中奖信息，以便第三方能及时向您发放奖品；或者在与其他公司进行资本市场活动
          </span>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            (包括但不限于IPO，债券发行)接受尽职调查时；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            基于学术研究：例如为科研机构开展统计或学术研究之必要；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            基于符合法律法规的社会公共利益等。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              <font face='宋体'>我们会通过应用程序接口（</font>
              API）、软件工具开发包（SDK）与第三方进行必要的数据共享，不同版本的第三方SDK会有所不同，
			  一般包括第三方账号登录类、分享类、第三方支付类、地图导航类、厂商推送类、统计类、语音识别类等，我们会对第三方进行严格的安全检测并约定数据保护措施。
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(0, 0, 255); text-decoration: underline; font-size: 10.5pt;' onClick={this.jumpToSdkcontents}>
            美团排队接入第三方SDK目录
          </span>
          <span style='font-family: 微软雅黑; font-size: 13.5pt;'>
            <br />
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              请您知悉，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，
			  对我们仅为实现本政策中声明的目的与之共享个人信息的公司、组织和个人，我们会与其签署严格的信息保护和保密协定，
			  要求他们遵守协议并采取相关的安全措施来保护您的个人信息。
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            （二）转让
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
            </span>
          </b>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            2、在我们发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，
			我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            （三）公开披露
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              我们不会公开披露您的个人信息，但以下情况除外：
            </span>
          </b>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            1、基于您的主动选择或获得您的明确同意，我们可能会公开您的相关个人信息；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            2、如果我们确定您出现违反法律法规或严重违反美团点评相关协议规则的情况，
			或为保护美团排队APP运营者及其关联公司用户或公众的人身财产安全免遭侵害以及维护良好的公平交易环境，
			我们可能依据法律法规或美团排队相关协议规则披露您的相关个人信息，例如若您销售不符合安全标准的商品而严重违反美团排队规则时，
			我们可能会公开披露您的店铺主体信息与相关处罚情况；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            3、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              四、我们如何保护您个人信息的安全
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            为保障您的信息安全，我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息，
			防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息，
			使用加密技术确保数据的保密性；使用受信赖的保护机制防止数据遭到恶意攻击；部署访问控制机制，确保只有授权人员才可访问个人信息；
			以及举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              在不幸发生个人信息安全事件后，我们将按照法律法规的要求，
			  及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。
			  我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
			  同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='font-size: 10.5pt;'>
              五、您如何管理您的个人信息
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              您有权访问、更正、删除您的个人信息，法律法规规定的例外情况除外。
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            1、您可以通过以下方式管理您的信息:
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='font-size: 10.5pt;'>账户信息</span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            ——您可以访问、查询、更正您账户中的个人资料及账号信息，
			如手机号、角色、职位、所属门店，也可以更改您的密码，您可以通过访问美团排队App在设置中执行此类操作。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>
              如果您无法通过上述链接管理这些个人信息，您可以随时通过本隐私政策中提供的反馈方式联系我们。我们将在
            </font>
            15天内回复您的访问请求。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            2、您可以改变您授权同意的范围或撤回授权
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>您可以通过在美团排队</font>
            App中通过相应页面提示进行更改、删除信息、更改隐私设置或者在系统中关闭设备权限功能等方式改变同意范围或撤回您的授权。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权已经开展的个人信息处理。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            3、您可以注销账户
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            您有权注销您的美团排队账户，您可以通过联系客服协助您进行账户注销。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>
              如果您无法通过上述方式管理这些个人信息，您可以随时通过本隐私政策中提供的反馈方式联系我们。我们将在
            </font>
            15天内回复您的请求并协助调整。在您更新或更正前，我们可能会先要求验证您的身份，然后再处理您的请求。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 12pt;'>&nbsp;</span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              六、您的个人信息如何在全球范围转移
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            我们在中华人民共和国境内运营中收集和产生的个人信息，存储在
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              中国境内
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            ，以下情形除外：
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            1、法律法规有明确规定；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            2、获得您的明确授权；
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            3、您通过互联网进行跨境交易等个人主动行为。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-family: 微软雅黑; font-size: 13.5pt;'>
            <br />
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              七、未成年人的个人信息保护
            </span>
          </b>
          <b>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            美团非常重视对未成年人个人信息的保护。我们的网站和服务主要面向成人。
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            &nbsp;
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            八、
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              通知与修订
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            为给您提供更好的服务，我们的业务将不时变化，本隐私政策也将随之调整。未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。
			我们会通过在我们网站、移动端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。
			在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本政策并受之约束。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-family: 微软雅黑; font-size: 13.5pt;'>
            <br />
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              九、如何联系我们
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>
            如果您对于我们的个人信息处理行为存在任何投诉举报需求，您可以通过隐私保护专用邮箱
          </span>
          <a href='mailto:privacy@meituan.com'>
            <u>
              <span
                class='16'
                style='font-family: Calibri; color: rgb(5, 99, 193);'
              >
                privacy@meituan.com
              </span>
            </u>
          </a>
          <span style='font-size: 10.5pt;'>
            或是
          </span>
          <span style='font-family: Calibri; font-size: 10.5pt;'>
            diancan.jiancha@meituan.com
          </span>
          <span style='font-size: 10.5pt;'>
            联系我们，
          </span>
          <span style='font-size: 13.5pt;'>&nbsp;</span>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            您还可以通过
          </span>
          <b>
            <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
              <font face='宋体'>我们的网站或美团排队</font>
              App上的客服系统与我们联系，
            </span>
          </b>
          <span style='color: rgb(51, 51, 51); font-size: 10.5pt;'>
            <font face='宋体'>并作充分描述，我们将在验证您身份的</font>
            15天内答复您的请求并尽力解决。如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向协议签订地北京市朝阳区人民法院提起诉讼。
          </span>
        </p>
        <p
          class='MsoNormal'
          style='margin: 0pt 0pt 0.0001pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>
            <br clear='all' style='break-before: page;' />
          </span>
        </p>
        <p
          class='p'
          style='margin-top: 5pt; margin-bottom: 5pt; font-size: 12pt;'
        >
          <span style='font-family: Helvetica; color: rgb(51, 51, 51); font-size: 12pt;'>
            <font face='宋体'>附录：</font>
          </span>
        </p>
        <p
          class='p'
          style='margin-top: 5pt; margin-bottom: 5pt; font-size: 12pt;'
        >
          <b>
            <span
              class='15'
              style='font-family: Helvetica; color: rgb(51, 51, 51);'
            >
              1
              <font face='等线'>
                、个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
				本隐私政策中可能涉及到的个人信息包括但不限于：个人基本信息（包括姓名、电话号码、性别、住址、生日等）；
				个人身份信息（包括身份证、军官证、护照、驾驶证等）；网络身份标识信息（包括系统账号、
              </font>
              <font face='Helvetica'>IP</font>
              <font face='等线'>
                地址、邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（包括银行账号、交易和消费记录、信贷记录以及虚拟财产信息等）；
				个人健康生理信息（包括病症、病历、病史等）；联系人信息（包括通讯录信息、好友列表等）；个人上网记录（包括网站浏览记录、点击记录等）；
				个人设备信息（包括唯一设备识别码等描述个人常用设备基本情况的信息）；个人位置信息（包括行踪轨迹、精准定位信息等）。
              </font>
            </span>
          </b>
        </p>
        <p
          class='p'
          style='margin-top: 5pt; margin-bottom: 5pt; font-size: 12pt;'
        >
          <b>
            <span
              class='15'
              style='font-family: Helvetica; color: rgb(51, 51, 51);'
            >
              2
              <font face='等线'>
                、个人敏感信息：是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。
				本隐私政策中可能涉及到的个人敏感信息包括：个人身份认证信息（包括身份证、军官证、护照、驾驶证、学生证等）；
				个人财产信息（银行账号、交易和消费记录、信贷记录以及虚拟财产信息等）；其他信息（行踪轨迹、通讯录信息、精准定位信息等）；
              </font>
              <font face='Helvetica'>14</font>
              <font face='等线'>周岁以下的儿童信息。</font>
            </span>
          </b>
        </p>
        <p
          class='MsoNormal'
          style='margin: 1.5pt 0pt; font-family: 等线; font-size: 10.5pt;'
        >
          <span style='font-size: 10.5pt;'>&nbsp;</span>
        </p>
      </div>
    );
  }
}

Agreement.run();



// WEBPACK FOOTER //
// ./src/pages/user-agreement/user-agreement.jsx